module.exports = __webpack_public_path__ + "assets/img/search_purple.ee7bae45.png";